import {
  Component,
  Input,
  Output,
  EventEmitter,
  Injector,
  HostListener,
  OnChanges,
  ElementRef,
  ViewChild,
  OnInit,
} from '@angular/core';
import { map } from 'rxjs/operators';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { PagedListingComponentBase } from '../../../paged-list-component-base';
import { MasterRepo } from '../../repositories';
import { FormBuilder, FormGroup } from '@angular/forms';
import { debounce } from 'lodash';
// import { HttpErrorResponse } from "@angular/common/http";
// import { LocalData } from "ng2-completer";
@Component({
  selector: 'generic-popup-grid',
  templateUrl: './generic-popup-grid.component.html',
  styleUrls: ['../../../pages/Style.css', '../pStyle.css'],
})
export class GenericPopUpComponent
  extends PagedListingComponentBase
  implements OnChanges, OnInit
{
  @ViewChild('genericGridModal') genericGridModal!: ModalDirective;
  /** List Declaration  */

  requestUrl: string = '';

  isActive: boolean = false;
  itemList: any[] = [];
  selectedRowIndex: number = 0;
  tabindex: string = 'list';

  //for transaction filter
  billTo: string = '';
  isForCancelOrder: boolean = false;
  tag: string = '';
  hostElementid: string = '';
  three: number = 3;
  /** Output  */

  @Output() onPopUpClose = new EventEmitter();
  @Output() onItemDoubleClick = new EventEmitter();

  /** Input  */

  @Input() popupsettings!: GenericPopUpSettings;
  @Input() inputVchrType: string = '';
  @Input() inputVchrno: string = '';
  @Input() summary!: string;
  @Input() multiSelectList: any[] = [];
  @ViewChild('inputBox') inputBox: ElementRef<HTMLInputElement> =
    {} as ElementRef;

  gridForm: FormGroup = this.fb.group({
    columnField: [{ value: '' }],
    valueField: [{ value: '' }],
  });

  constructor(
    public injector: Injector,
    private masterService: MasterRepo,
    private fb: FormBuilder
  ) {
    super(injector);
    this.masterService.ItemList_Available = '0';
    //this.hostElement = eleref.nativeElement.ownerDocument.activeElement;
  }
  ngOnInit(): void {
    const colField = this.gridForm.get('columnField');
    const valField = this.gridForm.get('valueField');
    var debounceTime = 1500;
    if (this.popupsettings?.multiSelect == true) {
      debounceTime = 1500;
    }
    this.triggerSearch = debounce(this.triggerSearch, 1500);
    colField!.valueChanges.subscribe((val) => {
      this.filterOption = val;
      this.triggerSearch(val, false);
    });
    valField!.valueChanges.subscribe((val) => {
      this.filterValue = val;
      this.triggerSearch(val, false);
    });
  }
  show(
    billTo: string = '',
    isForCancelOrder: boolean = false,
    tag: string = '',
    hostElementID: string = ''
  ) {
    console.log('popup show', this.popupsettings);
    // this.genericGridModal.show();
    this.hostElementid = hostElementID;
    setTimeout(() => {
      this.inputBox.nativeElement.focus();
    }, 10);
    this.summary = '';
    this.billTo = billTo;
    this.isForCancelOrder = isForCancelOrder;
    this.itemList = [];
    this.isActive = true;
    this.selectedRowIndex = 0;
    this.tag = tag;
    this.setFilterOption();

    setTimeout(() => {
      this.setFilterOption();
      this.refreshPage();
      this.refresh();
    }, 100);
  }

  setFilterOption() {
    if (this.popupsettings && this.popupsettings.columns.length) {
      let filterIndex = this.popupsettings.defaultFilterIndex
        ? this.popupsettings.defaultFilterIndex
        : 0;
      if (this.popupsettings.columns.length <= filterIndex) return;

      this.filterValue = '';
      this.filterOption = this.popupsettings.columns[filterIndex].key;
    }
  }

  getFilterOption(url: string): string {
    let filter = [];

    if (
      this.filterOption == null ||
      this.filterOption == undefined ||
      this.filterOption == ''
    )
      return url;
    if (
      this.filterValue == null ||
      this.filterValue == undefined ||
      this.filterValue == ''
    )
      return url;
    filter.push({ Field: this.filterOption, Value: this.filterValue });
    return `${url}&filter=${JSON.stringify(filter)}`;
  }

  getData() {
    if (this.popupsettings.DataSource == DataSourceType.ServerDataSource) {
      this.serverDataSource();
    } else {
      this.localDataSource();
    }
  }
  serverDataSource() {
    console.log('get data', this.filterOption, this.filterValue);
    this.summary = '';
    this.selectedRowIndex = 0;

    let apiEndpoints = this.popupsettings.apiEndpoints;
    console.log({
      CheckInputForm: this.inputVchrType,
      vchrno: this.inputVchrno,
    });
    let apiUrl = `${this.apiUrl}${apiEndpoints}?pageNumber=${this.pageNumber}&maxResultCount=${this.pageSize}`;
    if (this.inputVchrType.toLowerCase() == 'dispatchin') {
      apiUrl = apiUrl + `&dataFrom=dispatchin&vchrno=${this.inputVchrno}`;
    }
    // if (this.billTo && this.billTo != "" && this.billTo != null && this.billTo != undefined) {
    //   apiUrl = apiUrl + `&billTo=${this.billTo}`;
    // }
    // if (this.tag && this.tag != "" && this.tag != null && this.isTableLoading != undefined) {
    //   apiUrl = apiUrl + `&tag=${this.tag}`;
    // }
    // if (this.isForCancelOrder) {
    //   apiUrl = apiUrl + `&isForCancelOrder=${this.isForCancelOrder}`;
    // }

    this.requestUrl = this.getFilterOption(apiUrl);

    return (
      this._http
        .get(
          this.requestUrl,
          this.masterService.getRequestOption('application/json')
        )
        //.pipe(map((res: any) => res))
        .subscribe(
          (res: any) => {
            console.log('grid result', res);
            this.totalItems = res ? res.totalCount : 0;
            this.itemList = res ? res.result : [];

            console.log('itemList', this.itemList);
            if (this.itemList.length > 0) {
              this.masterService.ItemList_Available = '1';
            } else {
              this.masterService.ItemList_Available = '0';
            }
            //console.log("this.masterService.ItemList_Available",this.masterService.ItemList_Available);

            this.itemList.forEach(function (item) {
              if (item.TRNDATE != null && item.TRNDATE != undefined) {
                item.TRNDATE = item.TRNDATE.toString().substring(0, 10);
              }
              if (item.DATE != null && item.DATE != undefined) {
                item.DATE = item.DATE.toString().substring(0, 10);
              }
            });
            if (this.itemList[this.selectedRowIndex] != null) {
              this.itemList[this.selectedRowIndex].itemSummary;
            }

            if (
              this.itemList.length > 0 &&
              this.selectedRowIndex == 0 &&
              this.itemList[this.selectedRowIndex].itemSummary
            ) {
              this.summary = this.itemList[this.selectedRowIndex].itemSummary;
            }
          },
          (err: any) => {
            alert(JSON.stringify(err));
          }
        )
    );
  }

  localDataSource() {
    console.log({ localData: this.popupsettings });
    if (this.popupsettings.LocalData == null) {
      this.popupsettings.LocalData = [];
      return;
    }
    if (this.popupsettings.LocalData && !this.popupsettings.LocalData.length)
      return;
    this.totalItems = this.popupsettings.LocalData.length;
    this.itemList = this.popupsettings.LocalData;
    this.getFilterOptionLocal();
    this.setPageLocalData();
  }
  hide() {
    this.itemList = [];
    this.pageNumber = 1;
    this.totalItems = 0;
    this.isActive = false;
    console.log('hide button', this.isActive);
  }

  getFilterOptionLocal() {
    console.log({
      filterOpt: this.filterOption,
      filtervalue: this.filterValue,
    });
    let filter = [];
    this.itemList = this.popupsettings.LocalData;
    if (
      this.filterOption == null ||
      this.filterOption == undefined ||
      this.filterOption == ''
    )
      return;
    if (
      this.filterValue == null ||
      this.filterValue == undefined ||
      this.filterValue == ''
    )
      return;
    var localData = this.popupsettings.LocalData;
    var rgxp = new RegExp(this.filterValue, 'i');
    this.itemList = localData.filter((x) =>
      x[this.filterOption].toString().match(rgxp)
    );
    //this.pageNumber = 1;
    console.log({ regxp: rgxp, localData: localData, list: this.itemList });
  }

  setPageLocalData() {
    var toskip = (this.pageNumber - 1) * this.pageSize;
    var limit = this.pageSize;
    this.itemList = this.itemList.slice(toskip, limit + toskip);
    console.log({
      pageNumber: this.pageNumber,
      toskip: toskip,
      limit: limit,
      lst: this.itemList,
    });
  }

  triggerSearch(event: any, filterOption: any) {
    console.log('trigger search', this.filterOption, this.filterValue);
    if (
      this.filterOption == null ||
      this.filterOption == undefined ||
      this.filterOption == ''
    )
      return;

    if (filterOption == true) {
      this.filterValue = '';
    }

    this.refreshPage();
    this.refresh();
  }

  singleClick(index: any) {
    this.selectedRowIndex = index;
    this.summary = this.itemList[index].itemSummary;
  }

  doubleClick($event: any) {
    if (this.popupsettings.callingControlId) {
      this.onItemDoubleClick.emit({
        event: $event,
        callingControlId: this.popupsettings.callingControlId,
      });
    } else {
      if (this.popupsettings.multiSelect == true) {
        this.onItemDoubleClick.emit(this.multiSelectList);
      } else {
        this.onItemDoubleClick.emit($event);
      }
    }
    this.hide();
    this.focusAnyControl('');
  }

  conditionalStyle() {
    let style: any;

    for (let item of this.popupsettings.columns) {
      if (item.title.toUpperCase() == 'AMOUNT') {
        //console.log("amountstle",);
        style = { 'text-align': 'right' };
        return style;
      }
      style = { 'text-align': 'left' };
      return style;
    }
  }

  @HostListener('document : keydown', ['$event'])
  updown($event: KeyboardEvent) {
    if (!this.isActive) return;
    if ($event.code == 'ArrowDown') {
      $event.preventDefault();
      this.selectedRowIndex++;
      if (this.itemList[this.selectedRowIndex] != null) {
        this.summary = this.itemList[this.selectedRowIndex].itemSummary;
      }
      this.calculateTotalPages();
      if (
        this.selectedRowIndex == this.itemList.length &&
        this.pageNumber < this.totalPages
      ) {
        this.pageNumber = this.pageNumber + 1;
        this.refresh();
        this.selectedRowIndex = 0;
        this.itemListClosed();
      } else if (
        this.selectedRowIndex == this.itemList.length &&
        this.pageNumber == this.totalPages
      ) {
        this.selectedRowIndex = this.itemList.length - 1;
      }
      return;
    } else if ($event.code == 'ArrowUp') {
      $event.preventDefault();
      this.selectedRowIndex--;
      if (this.itemList[this.selectedRowIndex] != null) {
        this.summary = this.itemList[this.selectedRowIndex].itemSummary;
      }
      if (this.selectedRowIndex == -1 && this.pageNumber > 1) {
        this.pageNumber = this.pageNumber - 1;
        this.refresh();
        this.selectedRowIndex = this.itemList.length - 1;
        this.itemListClosed();
      } else if (this.selectedRowIndex == -1 && this.pageNumber == 1) {
        this.selectedRowIndex = 0;
      }
      return;
    } else if (
      $event.code == 'Enter' &&
      this.selectedRowIndex >= 0 &&
      this.selectedRowIndex < this.itemList.length
    ) {
      this.focusAnyControl('brand');
      //console.log("I am here")
      $event.preventDefault();
      if (this.filterOption == 'BARCODE') {
      } else {
        if (this.popupsettings.callingControlId) {
          this.onItemDoubleClick.emit({
            event: this.itemList[this.selectedRowIndex],
            callingControlId: this.popupsettings.callingControlId,
          });
        } else {
          this.doubleClick(this.itemList[this.selectedRowIndex]);
          //this.onItemDoubleClick.emit(this.itemList[this.selectedRowIndex]);
        }

        this.hide();
        this.itemListClosed();
      }
    } else if ($event.code == 'Escape') {
      $event.preventDefault();
      this.hide();
      this.itemListClosed();
      if (this.hostElementid) this.focusAnyControl(this.hostElementid);
    } else if ($event.code == 'ArrowRight') {
      $event.preventDefault();
      this.calculateTotalPages();
      if (this.pageNumber >= this.totalPages) {
        this.pageNumber = this.totalPages;
        return;
      }

      this.selectedRowIndex = 0;
      this.pageNumber = this.pageNumber + 1;
      this.refresh();
    } else if ($event.code == 'ArrowLeft') {
      $event.preventDefault();
      if (this.pageNumber <= 1) {
        this.pageNumber = 1;
        return;
      }
      this.selectedRowIndex = 0;
      this.pageNumber = this.pageNumber - 1;
      this.refresh();
      return;
    } else if ($event.code == 'Space' && $event.ctrlKey == true) {
      console.log({ keyevent: $event });
      this.onMultiSelectAdd(this.itemList[this.selectedRowIndex]);
    }
  }

  itemListClosed() {
    this.onPopUpClose.emit();
  }

  ngOnChanges(changes: any) {
    this.popupsettings = changes.popupsettings.currentValue;

    //console.log("poppup column setting",this.popupsettings);
  }

  focusAnyControl(id: string) {
    let control: any = document.getElementById(id);
    if (control != null) {
      setTimeout(() => {
        control.focus();
      });
    }
  }
  focusAndClickAnyControl(id: string) {
    let control: any = document.getElementById(id);
    if (control != null) {
      setTimeout(() => {
        control.focus();
        control.click();
      });
    }
  }
  ScrollIntoViewControl(id: string) {
    let control: any = document.getElementById(id);
    control.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  onMultiSelectAdd(item) {
    if (!this.multiSelectList.find((x) => x.value == item.value)) {
      this.multiSelectList.push(item);
    }
    this.onItemDoubleClick.emit(this.multiSelectList);
    console.log({ multiseleList: this.multiSelectList, item: item });
  }

  onMultiSelectDelete(item) {
    var ind = this.multiSelectList.findIndex((x) => x.value == item.value);
    this.multiSelectList.splice(ind, 1);
    this.onItemDoubleClick.emit(this.multiSelectList);
    console.log({ multiseleList: this.multiSelectList, item: item });
  }
}
// serverDataSource() {
//   if (!this.isActive) return true;
//   this.summary = "";
//   this.selectedRowIndex = 0;

//   let apiEndpoints = this.popupsettings.apiEndpoints;
//   let apiUrl = `${this.apiUrl}${apiEndpoints}?currentPage=${this.pageNumber}&maxResultCount=${this.pageSize}`;

//   if (
//     this.billTo &&
//     this.billTo != "" &&
//     this.billTo != null &&
//     this.billTo != undefined
//   ) {
//     apiUrl = apiUrl + `&billTo=${this.billTo}`;
//   }
//   if (
//     this.tag &&
//     this.tag != "" &&
//     this.tag != null &&
//     this.isTableLoading != undefined
//   ) {
//     apiUrl = apiUrl + `&tag=${this.tag}`;
//   }
//   if (this.isForCancelOrder) {
//     apiUrl = apiUrl + `&isForCancelOrder=${this.isForCancelOrder}`;
//   }

//   this.requestUrl = this.getFilterOption(apiUrl);

//   return this._http
//     .get(this.requestUrl)
//     .pipe(first())
//     .subscribe((res: any) => {
//       this.totalItems = res ? res["totalCount"] : 0;
//       this.itemList = res ? res["data"] : [];

//       this.itemList.forEach(function (item) {
//         if (item.TRNDATE != null && item.TRNDATE != undefined) {
//           item.TRNDATE = item.TRNDATE.toString().substring(0, 10);
//         }
//         if (item.DATE != null && item.DATE != undefined) {
//           item.DATE = item.DATE.toString().substring(0, 10);
//         }
//       });
//       if (this.itemList[this.selectedRowIndex] != null) {
//         this.itemList[this.selectedRowIndex].itemSummary;
//       }

//       if (
//         this.itemList.length > 0 &&
//         this.selectedRowIndex == 0 &&
//         this.itemList[this.selectedRowIndex].itemSummary
//       ) {
//         this.summary = this.itemList[this.selectedRowIndex].itemSummary;
//       }
//     });
// }

export class GenericPopUpSettings {
  title!: string;
  apiEndpoints!: string;
  columns: ColumnSettings[] = [];
  defaultFilterIndex: number = 0;
  showActionButton?: boolean = false;
  //actionKeys?: ActionKeySettings[] = [];
  DataSource!: DataSourceType;
  LocalData: any[] = [];
  pageSize?: number = 0;
  callingControlId?: string = '';
  multiSelect?: boolean = false;
}

export class ColumnSettings {
  key!: string;
  title!: string;
  hidden: boolean = false;
  noSearch: boolean = false;
  alignment?: string;
}
export enum DataSourceType {
  LocalDatasource,
  ServerDataSource,
}
// export function debounce(delay: number): MethodDecorator {
//   return function<any> (
//     target: any,
//     propertyKey: string,
//     descriptor: PropertyDescriptor<any>
//   ) {
//     const original = descriptor.value;
//     const key = `__timeout__${propertyKey}`;

//     descriptor.value = function (...args) {
//       clearTimeout(this[key]);
//       this[key] = setTimeout(() => original.apply(this, args), delay);
//     };

//     return descriptor;
//   };
// }

// function debounce<Params extends any[]>(
//   func: (...args: Params) => any,
//   timeout: number
// ): (...args: Params) => void {
//   let timer: NodeJS.Timeout;
//   return (...args: Params) => {
//     clearTimeout(timer);
//     timer = setTimeout(() => {
//       func(...args);
//     }, timeout);
//   };
// }

// function test(message:string) {
//   alert(message);
// }

// const debouncedTest = debounce(test, 2000);

// debouncedTest('message');
